import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom'; 

import { Container, Col, Accordion, Row, Button } from 'react-bootstrap';  
 
import './Product.css'; 
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import imgBox1 from './img/manos-corazon.webp';
import imgBox2 from './img/Sun-product.png'; 
import { LazyLoadImage } from 'react-lazy-load-image-component';


class Product extends Component {
    constructor () {
        super();
        let url  = window.location.href;
        let lang;
        if(url.search('/en') !== -1){
            lang='en';
        }else{
            lang='es';
        }
        var listaPalabras = JSON.stringify(require('../../translate/'+lang+'.json'));
        var wordList = JSON.parse(listaPalabras);
        if(lang == "es"){
            lang='';
        }else{
            lang=lang+'/';
        }
        this.state = {
            lang: lang,
            wordList: wordList.product,
            wordListUrl: wordList.url
        };
    }

    

    componentDidMount () { 
        document.querySelector('meta[name="description"]').setAttribute("content", this.state.wordList.descripcion);
        document.title = this.state.wordList.titulo; 
         
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        
        // menu bar
        document.getElementById('menu-1').classList.remove("nav-top-active");
        document.getElementById('menu-1').classList.add("nav-top");
        document.getElementById('menu-2').classList.remove("nav-top-active");
        document.getElementById('menu-2').classList.add("nav-top");
        document.getElementById('menu-3').classList.remove("nav-top-active");
        document.getElementById('menu-3').classList.add("nav-top");
        document.getElementById('menu-4').classList.remove("nav-top-active");  
        document.getElementById('bar-1').classList.add("hide-visibility");
        document.getElementById('bar-2').classList.add("hide-visibility");
        document.getElementById('bar-3').classList.add("hide-visibility");
        document.getElementById('bar-4').classList.add("hide-visibility");
        document.getElementById('bar-1').classList.remove("hide-visibility");
        document.getElementById('menu-1').classList.remove("nav-top-left");
        document.getElementById('menu-1').classList.add("nav-top-left-active");
    }
 

    render() {
        const { wordList, wordListUrl, lang } = this.state;
        return ( 
            <div id="product">
            <Header type={"dark"}/>
            <div className="background-box-product-1" id="product-box-1">
            <img src={imgBox1} className="img-hands-product"/>
            <Container className="contenido">
                 <Row className="box-1">
                     <Col md={12} lg={6} className="product-box-1">
                         <h1>{wordList.tituloInicial}</h1>
                         <p>{wordList.textoIntro}</p>
                         <p>{wordList.textoIntro2}</p>
                            <a  href="#box-2"><Button size="lg" className="border-button margin-top-45">{wordList.saber}  </Button></a>
                            <Link to={"/"+lang+""+wordListUrl.recommender1}><Button size="lg" className="box-button margin-left-15 margin-top-45">{wordList.asegurar}  </Button></Link>
                     </Col>
                     <Col xs={{ span: 12, offset: 0 }} className="images-sun-product">
                        <LazyLoadImage src={imgBox2} className="img-sun"/>
                     </Col>
                 </Row>
            </Container>  
            </div>
            <div className="background-box-product-2" id="box-2">
            <Container className="contenido">
                 <Row className="box-2 text-center" >
                     <Col md={12} lg={{ span: 6, offset: 3 }} style={{paddingLeft:"30px", paddingRight:"30px"}}>
                         <h2>{wordList.olvidate}</h2>
                         <p>{wordList.empezamos}</p> 
                     </Col>
                     <Col md={12} lg={4}>
                         <div className="box-home">
                            <div className="number-home">
                                1
                            </div>
                            <h3>{wordList.seguroVida}</h3>
                            <p>{wordList.seguroVidaTexto}</p>                         
                         </div>                          
                     </Col>
                     <Col md={12} lg={4}>
                         <div className="box-home-2">
                            <div className="number-home">
                                2
                            </div>
                            <h3>{wordList.necesidad}</h3>
                            <p>{wordList.necesidadTexto}</p>    
                         </div>     
                     </Col>
                     <Col md={12} lg={4}>
                         <div className="box-home-3">
                            <div className="number-home">
                                3
                            </div>
                            <h3>{wordList.unico}</h3>
                            <p>{wordList.unicoTexto}</p> 
                         </div>    
                     </Col>
                     <Col md={12} lg={{ span: 8, offset: 2 }} className="questions">
                            <h3>{wordList.preguntas}</h3>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>{wordList.paraQue}</Accordion.Header>
                                    <Accordion.Body  dangerouslySetInnerHTML={{__html:  wordList.paraQueTexto}}>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>{wordList.quienNecesita}</Accordion.Header>
                                    <Accordion.Body  dangerouslySetInnerHTML={{__html:  wordList.quienNecesitaTexto}}>
                                    </Accordion.Body>
                                </Accordion.Item>                                
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>{wordList.queCapital}</Accordion.Header>
                                    <Accordion.Body dangerouslySetInnerHTML={{__html: wordList.queCapitalTexto}}>
                                    </Accordion.Body>
                                </Accordion.Item>                        
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>{wordList.queFactores}</Accordion.Header>
                                    <Accordion.Body dangerouslySetInnerHTML={{__html: wordList.queFactoresTexto}}>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>{wordList.quienBeneficiario}</Accordion.Header>
                                    <Accordion.Body dangerouslySetInnerHTML={{__html: wordList.quienBeneficiarioTexto}}>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5" style={{borderBottom:"0px"}}>
                                    <Accordion.Header>{wordList.queLivetopic}</Accordion.Header>
                                    <Accordion.Body dangerouslySetInnerHTML={{__html: wordList.queLivetopicTexto}}>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                     </Col>
                 </Row>
            </Container> 
            </div>
            <Footer  type={"dark"}/>
            </div>
        );
    }
}

export default withRouter((Product));
